module.exports = __webpack_public_path__ + "img/collect-empty.9fb4e35d.png";